// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"dBrt2","mobile":"_6SdXm"};